import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface FilesKeyType {
  addFile: LocalesKey;
  changeFile: LocalesKey;
  attach: LocalesKey;
  attachFromProject: LocalesKey;
  areYouSureYouWantToDelete: LocalesKey;
  closeWhileUploadingTitle: LocalesKey;
  closeWhileUploadingDescription: LocalesKey;
  failedToUpload: LocalesKey;
  fileFromComputer: LocalesKey;
  fileFromProject: LocalesKey;
  filesAdded: LocalesKey;
  filesAttached: LocalesKey;
  fileUploaded: LocalesKey;
  jpg: LocalesKey;
  plural: LocalesKey;
  png: LocalesKey;
  removeFiles: LocalesKey;
  restoreFiles: LocalesKey;
  selectFileFormat: LocalesKey;
  selectFiles: LocalesKey;
  startFilesUploading: LocalesKey;
  tiff: LocalesKey;
  uploadToLd: LocalesKey;
  viewLdFile: LocalesKey;
}

export const filesKeys = keyPathMirror<FilesKeyType, string>(
  {
    addFile: null,
    changeFile: null,
    attach: null,
    attachFromProject: null,
    areYouSureYouWantToDelete: null,
    closeWhileUploadingTitle: null,
    closeWhileUploadingDescription: null,
    failedToUpload: null,
    fileFromComputer: null,
    fileFromProject: null,
    filesAdded: null,
    filesAttached: null,
    fileUploaded: null,
    jpg: null,
    plural: null,
    png: null,
    removeFiles: null,
    restoreFiles: null,
    selectFileFormat: null,
    selectFiles: null,
    startFilesUploading: null,
    tiff: null,
    uploadToLd: null,
    viewLdFile: null
  },
  'models.files.'
);
